export const faceBookPixel = (action, event, props = null) => {

    if (typeof window !== "undefined") {
        if (window.fbq != null) {

            if (props) {
                window.fbq(action, event, props)
            } else {
                window.fbq(action, event)
            }

        }
    }

}